import { createClient } from '@supabase/supabase-js'
import { config } from './env'

let supabase = null;

// Aceita a URL nativa do Supabase (*.supabase.co) ou um reverse proxy próprio
// (ex.: https://app.giobrain.com/supabase) usado para contornar DNS bloqueado.
const isSupabaseLike = (url) => {
  if (!url) return false;
  try {
    const u = new URL(url);
    return u.protocol === 'https:' && (
      u.hostname.endsWith('.supabase.co') ||
      u.pathname.replace(/\/$/, '').endsWith('/supabase')
    );
  } catch {
    return false;
  }
};

const isValidConfig = config.supabase.url &&
  config.supabase.anonKey &&
  config.supabase.url !== 'https://seu-projeto.supabase.co' &&
  config.supabase.url !== 'https://seu-projeto-id.supabase.co' &&
  config.supabase.anonKey !== 'sua-chave-anonima-aqui' &&
  config.supabase.anonKey !== 'sua-chave-anonima-supabase-aqui' &&
  isSupabaseLike(config.supabase.url) &&
  config.supabase.anonKey.length > 50;

// Deriva uma chave de storage estável mesmo quando usamos um proxy próprio.
// Prefere o ref do projeto no JWT (iss/ref) para permanecer consistente
// entre builds que apontam direto para supabase.co e builds via proxy.
const getProjectRef = () => {
  try {
    const url = new URL(config.supabase.url);
    if (url.hostname.endsWith('.supabase.co')) {
      return url.hostname.split('.')[0];
    }
    const parts = config.supabase.anonKey.split('.');
    if (parts.length >= 2) {
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      if (payload?.ref) return payload.ref;
    }
  } catch {}
  return 'proxied';
};

if (isValidConfig) {
  try {
    const storageKey = `sb-${getProjectRef()}-auth-token`;
    const stored = localStorage.getItem(storageKey);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (!parsed?.access_token || !parsed?.refresh_token) {
          localStorage.removeItem(storageKey);
        }
      } catch {
        localStorage.removeItem(storageKey);
      }
    }

    supabase = createClient(config.supabase.url, config.supabase.anonKey, {
      auth: {
        // implicit: recuperação por e-mail funciona em qualquer navegador/dispositivo.
        // pkce exige code_verifier no mesmo browser que chamou resetPasswordForEmail —
        // abrir o link no app de e-mail/celular/outro PC quebra o exchange (?code=) e
        // aparece "token inválido". OAuth (ex.: Google) segue ok com detectSessionInUrl.
        flowType: 'implicit',
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      },
    });
  } catch (error) {
    supabase = null;
  }
}

export { supabase };

// Configuração para autenticação Google
export const authConfig = {
  google: {
    redirectTo: `${window.location.origin}/auth/callback`
  }
}
